import { Tooltip } from "@mantine/core";
import { type ReactNode, useRef, useState } from "react";
import "./TruncatedHeader.scss";

interface TruncatedHeaderProps {
  children: ReactNode;
}

function TruncatedHeader({ children }: TruncatedHeaderProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [opened, setOpened] = useState(false);

  return (
    <Tooltip label={children} opened={opened}>
      <span
        className="TruncatedHeader"
        ref={ref}
        onMouseEnter={() => {
          const el = ref.current;
          if (el && el.scrollHeight > el.clientHeight) setOpened(true);
        }}
        onMouseLeave={() => setOpened(false)}
      >
        {children}
      </span>
    </Tooltip>
  );
}

export { TruncatedHeader };
